var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"title-bar"},[_c('div',{staticClass:"title"},[_vm._v("\n    "+_vm._s(this.title)+"\n  ")]),_c('div',{staticClass:"bottom"})])}
var staticRenderFns = []

export { render, staticRenderFns }